export default {"src":"/education/_next/static/media/arrow-right-black.a55040e2.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};